import axios from 'axios';



// let _get_arr = decodeURI(location.search).replace('?', '').split('&') || [],
//     _get = {};

// if (_get_arr.length) {
//     _get_arr.forEach(function (e) {
//         let key = e.split('=')[0];
//         _get[key] = e.split('=')[1];
//     })
// }


let token = localStorage.getItem('fotty_token') || '',
    baseURL = process.env.NODE_ENV === 'production' ? '/api' : 'https://fotty.ru/api';

// if (_get['token']) token = _get['token'];

axios.defaults.baseURL = baseURL;
axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;

export default axios;